import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import { LpgVisibleOutline, LpgInvisibleOutline } from "@/icons";

import { Input } from "./index";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export const InputPassword = forwardRef((props, ref) => {
  const [type, setType] = useState("password");

  const { children, ...otherProps } = props;

  return (
    <Input
      ref={ref}
      type={type}
      button={{
        icon: type === "password" ? LpgVisibleOutline : LpgInvisibleOutline,
        onClick: () => {
          setType(type === "password" ? "text" : "password");
        },
        label: "Toggle password",
      }}
      {...otherProps}
    >
      {children}
    </Input>
  );
});

InputPassword.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

InputPassword.displayName = "InputPassword";

export default InputPassword;
